import React, { useEffect, useState } from "react";

type LeaderboardEntry = { name: string; score: number; finishTimeMs: number; createdAt: number };

export function Leaderboard({ onClose }: { onClose: () => void }) {
	const [entries, setEntries] = useState<LeaderboardEntry[] | null>(null);
	const [error, setError] = useState(false);

	useEffect(() => {
		fetch("/api/leaderboard")
			.then((response) => response.json() as Promise<{ entries: LeaderboardEntry[] }>)
			.then((body) => setEntries(body.entries))
			.catch(() => setError(true));
	}, []);

	return (
		<div className="leaderboard">
			<h2>Leaderboard — Top 20</h2>
			{error && <p>Couldn&apos;t load the leaderboard.</p>}
			{!error && !entries && <p>Loading…</p>}
			{entries && entries.length === 0 && <p>No runs finished yet — be the first!</p>}
			{entries && entries.length > 0 && (
				<table>
					<thead>
						<tr>
							<th>#</th>
							<th>Name</th>
							<th>Score</th>
							<th>Time</th>
						</tr>
					</thead>
					<tbody>
						{entries.map((entry, index) => (
							<tr key={`${entry.name}-${entry.createdAt}-${index}`}>
								<td>{index + 1}</td>
								<td>{entry.name}</td>
								<td>{entry.score}</td>
								<td>{(entry.finishTimeMs / 1000).toFixed(1)}s</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
			<button onClick={onClose}>Close</button>
		</div>
	);
}
